import api from '../config/api';

// City API Service
const cityAPI = {
  // Get all active cities
  getPublicCities: async (country = null) => {
    try {
      const url = country ? `/cities?country=${country}` : '/cities';
      const res = await api.get(url);
      
      // Handle different response formats
      let cities = res.data;
      if (Array.isArray(cities)) {
        return cities;
      } else if (cities && typeof cities === 'object') {
        // If response is wrapped, try to unwrap it
        return cities.cities || cities.data || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching cities:', error);
      throw error;
    }
  },

  // Get city by ID
  getCityById: async (cityId) => {
    try {
      const res = await api.get(`/cities/${cityId}`);
      return res.data;
    } catch (error) {
      console.error('Error fetching city:', error);
      throw error;
    }
  }
};

export default cityAPI;
